{
  "columns": {
    "launchedAt": "Date",
    "name": "Name",
    "rowsCount": "Rows",
    "status": "Status"
  },
  "export": {
    "generate": "Generate export",
    "load": "Load configurations",
    "notifications": {
      "generate": {
        "success": "Export request successfully created"
      },
      "load": {
        "success": "Export configurations successfully synchronized"
      }
    },
    "placeholder": "Select an export"
  },
  "import": {
    "bulkUpdate": {
      "summaryModal": {
        "confirmButton": {
          "label_one": "Launch and update {{ count }} product",
          "label_many": "Launch and update {{ count }} products",
          "label_other": "Launch and update {{ count }} products"
        },
        "erroredRows_one": "{{ count }} errored row",
        "erroredRows_many": "{{ count }} errored rows",
        "erroredRows_other": "{{ count }} errored rows",
        "errorMessage": "An error occurred while updating the products",
        "errorTitle": "Error",
        "successMessage": "Products bulk updated successfully",
        "successTitle": "Success",
        "title": "Bulk Product Update Summary",
        "totalRows_one": "{{ count }} total row",
        "totalRows_many": "{{ count }} total rows",
        "totalRows_other": "{{ count }} total rows",
        "validRows_one": "{{ count }} valid row",
        "validRows_many": "{{ count }} valid rows",
        "validRows_other": "{{ count }} valid rows",
        "warnedRows_one": "{{ count }} warned row",
        "warnedRows_many": "{{ count }} warned rows",
        "warnedRows_other": "{{ count }} warned rows",
        "warningsTitle": "Warnings found"
      },
      "templateCard": {
        "description": "Update multiple products at once by uploading a CSV file. Admin only feature. For more information, see the <a>documentation</a>.",
        "title": "Bulk Product Update",
        "uploadButton": {
          "label": "Upload file",
          "tooltip": "Maximum size: {{ maxSize }} MB"
        }
      }
    },
    "businessPartner": {
      "templateCard": {
        "description": "Build a repository for all your business partners information and contact details.",
        "title": "Business Partners",
        "uploadButton": {
          "label": "Upload file",
          "tooltip": "Maximum size: {{ maxSize }} MB"
        }
      }
    },
    "legacy": {
      "templateCard": {
        "description": "Share all products and procurement information at once, from product characteristics and composition to procurement details. This unique .csv file requires further treatment from the support team.",
        "downloadButton": {
          "label": "Template",
          "tooltip": "Download a template file."
        },
        "title": "Legacy ingestion file",
        "uploadButton": {
          "label": "Upload file",
          "tooltip": "Maximum size: {{ maxSize }} MB"
        }
      }
    },
    "list": {
      "filters": {
        "error": "Error",
        "failed": "Failed",
        "pending": "Pending",
        "search": "Search",
        "success": "Success",
        "title": "Filters"
      },
      "table": {
        "columns": {
          "date": {
            "header": "Date",
            "tooltip": "Date and time of the import."
          },
          "file": {
            "header": "File",
            "tooltip": "Name of the file"
          },
          "rows": {
            "header": "Rows",
            "tooltip": "Number of rows in the file"
          },
          "status": {
            "cell": {
              "error": "Error",
              "failed": "Failed",
              "pending": "Pending",
              "success": "Success"
            },
            "header": "Status",
            "tooltip": "Pending, Failed, Error, Success"
          },
          "type": {
            "header": "Type",
            "tooltip": "Type of imported data."
          },
          "user": {
            "header": "Owner",
            "tooltip": "User responsible for the import."
          }
        }
      }
    }
  },
  "page": {
    "title": "Data Hub"
  },
  "tabs": {
    "export": "Export",
    "import": "Import"
  },
  "templateDocumentation": "Documentation",
  "upload": {
    "erase": "😢 Your data has been erased, please upload new file",
    "error": "An error occurred while uploading your data",
    "info": "Trace For Good is committed to verifying format for the data provided in this file, but cannot guarantee its content. Therefore, it is the user's responsibility to ensure that the provided data is accurate and consistent.",
    "success": "🎉 Your data has been uploaded! Traceability starts now"
  }
}
